import { Component, computed, ElementRef, inject, ViewChild } from '@angular/core';
import { CitationFacade } from '../../../../_core/state/dialogs/citation/citation.facade';
import { LocaleService } from '../../../../services/locale.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { CitationStyle } from '../../../../_core/services/dialogs/citation/citation.model';
import { ToastService } from '../../../../_core/services/toast.service';

@Component({
  selector: 'opac-citation-dialog',
  templateUrl: './citation-dialog.component.html',
  styleUrls: ['./citation-dialog.component.scss'],
})
export class CitationDialogComponent {
  private readonly citationFacade = inject(CitationFacade);
  private readonly localeService = inject(LocaleService);
  private readonly toastService = inject(ToastService);

  readonly isLoading = toSignal(this.citationFacade.isLoading$);
  readonly isOpen = toSignal(this.citationFacade.isOpen$);
  readonly record = toSignal(this.citationFacade.record$);
  readonly styles = toSignal(this.citationFacade.styles$);
  readonly selectedStyle = toSignal(this.citationFacade.selectedStyle$);

  readonly modalTitle = computed(() => {
    return this.localeService.instant('citations.dialog.title') + this.record()?.title;
  });

  @ViewChild('citationOutput') citationOutput!: ElementRef<HTMLDivElement>;

  closeCitationModal() {
    this.citationFacade.closeCitationModal();
  }

  copyToClipboard() {
    if (!this.selectedStyle()) {
      return;
    }

    navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': new Blob([this.citationOutput.nativeElement.innerText], { type: 'text/plain' }),
        'text/html': new Blob([this.citationOutput.nativeElement.innerHTML], { type: 'text/html' }),
      }),
    ]).then(() => {
      this.toastService.showToast('citations.dialog.copied.description', 'info');
    });
  }

  setSelectedCitationStyle(style: CitationStyle) {
    this.citationFacade.setSelectedCitationStyle(style);
  }
}
